<app-detail-drawer eyebrow="Secure connection" title="Network status" (closed)="close()">
    <div class="zm">
        <div class="zm-summary" id="ZitiMetricsSummary">
            <span class="nf-badge" [ngClass]="overallTone">
                <span class="nf-badge-dot"></span>
                {{ overallLabel }}
            </span>
            <p class="zm-summary__text">{{ overallText }}</p>
            @if (canRetry) {
            <button type="button" class="nf-btn nf-btn--primary" (click)="retry()" id="ZitiMetricsRetry">Retry connection</button>
            }
        </div>

        <section class="zm-block" aria-labelledby="ZitiMetricsControllerTitle">
            <h3 class="zm-block__title" id="ZitiMetricsControllerTitle">Controller</h3>
            <div class="zm-conn">
                <span class="nf-badge zm-conn__badge" [ngClass]="controllerTone">{{ controllerLabel }}</span>
                @if (state.controllerUrl) {
                <ng-container *ngTemplateOutlet="copyButton; context: { $implicit: state.controllerUrl, id: 'ZitiMetricsCopyController' }"></ng-container>
                <span class="zm-conn__addr" id="ZitiMetricsControllerUrl">{{ state.controllerUrl }}</span>
                } @else {
                <span class="zm-conn__empty">Not connected</span>
                }
            </div>
        </section>

        <section class="zm-block" aria-labelledby="ZitiMetricsRoutersTitle">
            <h3 class="zm-block__title" id="ZitiMetricsRoutersTitle">Edge routers</h3>
            @for (er of routers; track er.url; let i = $index) {
            <div class="zm-conn">
                <span class="nf-badge zm-conn__badge" [ngClass]="er.tone">{{ er.label }}</span>
                @if (er.copyable) {
                <ng-container *ngTemplateOutlet="copyButton; context: { $implicit: er.url, id: 'ZitiMetricsCopyRouter' + i }"></ng-container>
                }
                <span class="zm-conn__addr">{{ er.url }}</span>
            </div>
            } @empty {
            <p class="nf-note" id="ZitiMetricsNoRouters">No edge router is connected.</p>
            }
        </section>

        <section class="zm-block" aria-labelledby="ZitiMetricsTrafficTitle">
            <h3 class="zm-block__title" id="ZitiMetricsTrafficTitle">Traffic</h3>
            <div class="zm-tiles">
                <div class="zm-tile">
                    <span class="zm-tile__value">{{ metrics.requestCount | number }}</span>
                    <span class="zm-tile__label">Requests</span>
                </div>
                <div class="zm-tile" [class.zm-tile--err]="metrics.requestErrors > 0">
                    <span class="zm-tile__value">{{ metrics.requestErrors | number }}</span>
                    <span class="zm-tile__label">Errors</span>
                </div>
                <div class="zm-tile">
                    <span class="zm-tile__value">{{ metrics.avgRequestDurationMs | number: '1.0-0' }}<span class="zm-tile__unit">ms</span></span>
                    <span class="zm-tile__label">Average latency</span>
                </div>
                <div class="zm-tile">
                    <span class="zm-tile__value">{{ metrics.lastRequestDurationMs | number: '1.0-0' }}<span class="zm-tile__unit">ms</span></span>
                    <span class="zm-tile__label">Last request</span>
                </div>
            </div>
            <dl class="zm-list">
                <div class="zm-list__row">
                    <dt>Data sent</dt>
                    <dd>{{ bytesSent }}</dd>
                </div>
                <div class="zm-list__row">
                    <dt>Data received</dt>
                    <dd>{{ bytesReceived }}</dd>
                </div>
                <div class="zm-list__row">
                    <dt>Reconnects</dt>
                    <dd>{{ metrics.reconnects | number }}</dd>
                </div>
            </dl>
        </section>
    </div>
</app-detail-drawer>

<ng-template #copyButton let-value let-id="id">
    <button
        type="button"
        class="zm-copy"
        [id]="id"
        [class.is-copied]="copied === value"
        [attr.aria-label]="copied === value ? 'Copied' : 'Copy address'"
        [matTooltip]="copied === value ? 'Copied' : 'Copy address'"
        matTooltipPosition="left"
        (click)="copy(value)">
        @if (copied === value) {
        <svg viewBox="0 0 16 16" aria-hidden="true">
            <path d="M3.5 8.5 6.5 11.5 12.5 4.5" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        } @else {
        <svg viewBox="0 0 16 16" aria-hidden="true">
            <rect x="5.5" y="5.5" width="8" height="8" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.5" />
            <path d="M3.5 10.5h-.25A.75.75 0 0 1 2.5 9.75v-6.5a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 .75.75v.25" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        </svg>
        }
    </button>
</ng-template>
